// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3u29j","message":"style_message__2reIm"};